import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLocale } from "../lib/useLocale";
import { NotebookPen, Stethoscope, ArrowRight } from "lucide-react";

export const FollowUpSection = () => {
  const { t } = useTranslation();
  const { path: lp } = useLocale();
  const f = t("followup", { returnObjects: true });

  const openConcierge = () => window.dispatchEvent(new Event("open-concierge"));

  return (
    <section data-testid="followup-section" className="border-y border-rr-line bg-rr-surface/30">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-28">
        <div className="max-w-2xl mb-14">
          <span className="overline">{f.overline}</span>
          <h2 className="font-heading text-5xl md:text-6xl mt-3 text-rr-ivory leading-[1.02]">{f.title}</h2>
        </div>
        <div className="grid md:grid-cols-2 gap-6">
          <div data-testid="followup-journal" className="group rounded-xl border border-rr-line hover:border-rr-gold/50 bg-rr-bg/40 p-9 md:p-11 transition-colors flex flex-col">
            <NotebookPen className="w-9 h-9 text-rr-gold" strokeWidth={1.3} />
            <h3 className="font-heading text-3xl text-rr-ivory mt-6">{f.journalTitle}</h3>
            <p className="text-rr-ivory/65 text-base leading-relaxed mt-4 flex-1">{f.journalText}</p>
            <Link to={lp("/trips")} data-testid="followup-journal-cta" className="btn-outline w-fit px-7 py-3.5 mt-8 flex items-center gap-2 text-xs uppercase">
              {f.journalCta} <ArrowRight className="w-4 h-4" strokeWidth={1.8} />
            </Link>
          </div>
          <div data-testid="followup-consult" className="group rounded-xl border border-rr-gold/40 bg-rr-gold/[0.04] p-9 md:p-11 transition-colors flex flex-col">
            <Stethoscope className="w-9 h-9 text-rr-gold" strokeWidth={1.3} />
            <h3 className="font-heading text-3xl text-rr-ivory mt-6">{f.consultTitle}</h3>
            <p className="text-rr-ivory/65 text-base leading-relaxed mt-4 flex-1">{f.consultText}</p>
            <button onClick={openConcierge} data-testid="followup-consult-cta" className="btn-gold w-fit px-7 py-3.5 mt-8 flex items-center gap-2 text-xs uppercase">
              {f.consultCta} <ArrowRight className="w-4 h-4" strokeWidth={1.8} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};
